import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import weui from "weui.js";
import {
  Cell,
  CellBody,
  CellDescription,
  CellFooter,
  CellHeader,
  Cells,
  Label,
  Loadmore
} from "../../components/weui";
import { userService } from "../../services";
import { urls } from "../../urls";
import { formatCurrency, formatDateTime, getAxiosError } from "../../utils";

import "./index.css";

export const PaymentList = (props) => {
  const navigate = useNavigate();

  const pageSize = 10;
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [orders, setOrders] = useState([]);

  const reload = useCallback(async () => {
    if (!hasMore) return;

    setLoading(true);
    try {
      const res = await userService.getOrders(page, pageSize);
      const newOrders = orders.concat(res.data.orders);
      setOrders(newOrders);
      setPage(page + 1);
      setHasMore(res.data.totalCount > newOrders.length);
    } catch (err) {
      weui.topTips(getAxiosError(err));
    } finally {
      setLoading(false);
    }
  }, [hasMore, setHasMore, setLoading, orders, setOrders, page, setPage]);

  useEffect(() => {
    if (page === 1) {
      reload();
    }
  }, [page, reload]);

  // 跳转详情页面
  const toDetail = (orderNo) => {
    navigate(urls.paymentDetail(orderNo));
  };

  const renderOrder = o => {
    return <Cell access key={ o.id } onClick={ e => toDetail(o.orderNo) }>
      <CellHeader>
        <Label>{ o.name }</Label>
        <CellDescription>{ o.meterNo }</CellDescription>
        <CellDescription>{ o.corpName }</CellDescription>
      </CellHeader>
      <CellBody></CellBody>
      <CellFooter>
        <CellDescription>{ formatCurrency(o.totalMoney) }</CellDescription>
        <CellDescription>{ o.orderState }</CellDescription>
        <CellDescription>{ formatDateTime(
          new Date(o.createTime)) }</CellDescription>
      </CellFooter>
    </Cell>;
  };

  return (
    <>
      <Cells>
        { orders?.length > 0 && orders.map(o => renderOrder(o)) }
      </Cells>
      <Loadmore
        loading={ loading }
        line
        dot={ !hasMore }
        onClick={ e => hasMore && reload() }>
        { loading ? "加载中..." : "加载更多" }
      </Loadmore>
    </>
  );
};
